var textCards = document.querySelectorAll('.text-cards-container .text-card');

[].slice.call(textCards).forEach(function(textCard) {
	var texCardtWaypoint = new Waypoint({
		element: textCard,
		handler: function(direction) {
			if(checkWidth(480))
				setCurrentCard(textCard);
		},
		offset: '60%'
	});

	textCard.addEventListener('click', function() {
		setCurrentCard(this);
	});
});

function setCurrentCard(textCard) {
	var current = textCard.parentNode.querySelector('.current');

	if(current && current != textCard)
		current.classList.remove('current');

	textCard.classList.add('current');
}

window.addEventListener('resize', function() {
	var current = document.querySelector('.text-cards-container .text-card.current');

	if(current && !checkWidth(480))
		current.classList.remove('current');
});

body.addEventListener('click', function(e) {
	var current = document.querySelector('.text-cards-container .text-card.current');

	if(current && current != e.target)
		current.classList.remove('current');
});